//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: "PopUpEnterCode",

  data: function () {
    return {
      code: "",

      open: false
    }
  },

  props: {
    isBlock: {
      type: Boolean,
      default: false
    }
  },

  methods: {
    openForm: function () {
      this.code = "";
      this.open = true;
    },
    closeForm: function () {
      this.open = false;
    },

    sendCode: function () {
      if (this.code.length !== 4) {
        this.$toast.error("Код должен содержать 4 символа")

        return
      }
      this.$emit("submit", this.code);
    },
  }
}
